import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, LockIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="mt-24 bg-ink text-white" data-id="element-167" data-mp="3r91a4moc6x8a">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8" data-id="element-168" data-mp="3mh136a9un427">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-169" data-mp="3mfgbqtiu018k">
          <div data-id="element-170" data-mp="3hhof5m78rqy1">
            <p className="font-display text-2xl font-semibold leading-snug" data-id="element-171" data-mp="3hi6dcodgsf8l">
              Turning impact into <span className="text-signal-light" data-id="element-172" data-mp="3di5zp5y6w82l">investable solutions</span>.
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-173" data-mp="38g6wbw2g9b5n">
              Human Planet convenes governments, investors and ventures at the intersection of capital markets and
              measurable impact. Attendance at our events is by review.
            </p>
          </div>

          <div data-id="element-174" data-mp="11qs9wqipfc08">
            <h2 className="eyebrow text-white/40" data-id="element-175" data-mp="11p7lzjqwarbc">Events</h2>
            <ul className="mt-4 space-y-3 text-sm text-white/80" data-id="element-176" data-mp="wta59cbpziy1">
              <li data-id="element-177" data-mp="15r4yypq74uly">
                <Link to="/" className="transition-colors hover:text-white" data-id="element-178" data-mp="15qlqdzmfrikl">
                  Upcoming events
                </Link>
              </li>
              <li data-id="element-179" data-mp="1anlnvm57zd03">
                <Link to="/past-events" className="transition-colors hover:text-white" data-id="element-180" data-mp="vsxkqenakqnn">
                  Past events
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-181" data-mp="1ohcx0tf1guva">
            <h2 className="eyebrow text-white/40" data-id="element-182" data-mp="1ogtg9g14kciu">Contact</h2>
            <ul className="mt-4 space-y-3 text-sm text-white/80" data-id="element-183" data-mp="1ojfxk7dti6e9">
              <li data-id="element-184" data-mp="1tf4qhrvc0p1l">
                <a href="mailto:events@human-planet.com" className="transition-colors hover:text-white" data-id="element-185" data-mp="1tfo6v45c35di">
                  events@human-planet.com
                </a>
              </li>
              <li data-id="element-186" data-mp="1jp1z1w3uzj5d">
                <a href="https://human-planet.com" className="inline-flex items-center gap-1 transition-colors hover:text-white" data-id="element-187" data-mp="1jojtg8vb3sks">
                  human-planet.com
                  <ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-188" data-mp="2m2xp625i3ede" />
                </a>
              </li>
              <li className="text-white/50" data-id="element-189" data-mp="2h3thxh24zqpp">Headquartered in Germany. Partners across Europe, MENA, Asia and North America.</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/15 pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-190" data-mp="2d0eq7t4u5lwf">
          <p data-id="element-191" data-mp="234lc45bgxkcj">© {new Date().getFullYear()} Human Planet. All rights reserved.</p>
          <Link to="/admin" className="inline-flex items-center gap-1.5 transition-colors hover:text-white" data-id="element-192" data-mp="1ydbotbde6t3t">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-193" data-mp="1tdqs77lp2wu9" />
            Human Planet admin
          </Link>
        </div>
      </div>
    </footer>;
}